import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import SectionHeading from "../components/SectionHeading";
import { useAuth } from "../context/AuthContext";
import { labGuideMeta } from "../config/products";
import { supabase } from "../lib/supabase";
import "./Lab.css";
import "./ProductTemplate.css";

// SVG Illustrations for dark web guide
function IcebergSVG() {
  return (
    <div className="lab-illustration">
      <svg viewBox="0 0 800 400" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="icebergGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#c0a062" stopOpacity="0.1" />
            <stop offset="100%" stopColor="#c0a062" stopOpacity="0.05" />
          </linearGradient>
        </defs>
        <rect
          x="100"
          y="50"
          width="600"
          height="80"
          rx="12"
          fill="url(#icebergGrad)"
          stroke="#c0a062"
          strokeWidth="2"
          opacity="0.9"
        />
        <text
          x="400"
          y="95"
          textAnchor="middle"
          fontSize="20"
          fontWeight="600"
          fill="currentColor"
        >
          Surface Web
        </text>
        <text
          x="400"
          y="120"
          textAnchor="middle"
          fontSize="14"
          fill="currentColor"
          opacity="0.7"
        >
          5% of internet
        </text>
        <rect
          x="150"
          y="160"
          width="500"
          height="100"
          rx="12"
          fill="url(#icebergGrad)"
          stroke="#c0a062"
          strokeWidth="2"
          opacity="0.7"
        />
        <text
          x="400"
          y="205"
          textAnchor="middle"
          fontSize="20"
          fontWeight="600"
          fill="currentColor"
        >
          Deep Web
        </text>
        <text
          x="400"
          y="235"
          textAnchor="middle"
          fontSize="14"
          fill="currentColor"
          opacity="0.7"
        >
          90% of internet
        </text>
        <rect
          x="200"
          y="290"
          width="400"
          height="90"
          rx="12"
          fill="url(#icebergGrad)"
          stroke="#c0a062"
          strokeWidth="2"
          opacity="0.5"
        />
        <text
          x="400"
          y="330"
          textAnchor="middle"
          fontSize="20"
          fontWeight="600"
          fill="currentColor"
        >
          Dark Web
        </text>
        <text
          x="400"
          y="360"
          textAnchor="middle"
          fontSize="14"
          fill="currentColor"
          opacity="0.7"
        >
          5% of internet
        </text>
      </svg>
    </div>
  );
}

function OnionRoutingSVG() {
  return (
    <div className="lab-illustration">
      <svg viewBox="0 0 800 300" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="onionGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#c0a062" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#c0a062" stopOpacity="0.1" />
          </linearGradient>
          <marker
            id="arrow"
            markerWidth="10"
            markerHeight="10"
            refX="8"
            refY="3"
            orient="auto"
          >
            <path d="M0,0 L0,6 L9,3 z" fill="#c0a062" />
          </marker>
        </defs>
        <circle
          cx="100"
          cy="150"
          r="40"
          fill="url(#onionGrad)"
          stroke="#c0a062"
          strokeWidth="2"
        />
        <text
          x="100"
          y="155"
          textAnchor="middle"
          fontSize="16"
          fontWeight="600"
          fill="currentColor"
        >
          User
        </text>
        <line
          x1="150"
          y1="150"
          x2="230"
          y2="150"
          stroke="#c0a062"
          strokeWidth="2"
          markerEnd="url(#arrow)"
        />
        <text
          x="190"
          y="135"
          textAnchor="middle"
          fontSize="11"
          fill="currentColor"
          opacity="0.6"
        >
          Encrypted
        </text>
        <circle
          cx="270"
          cy="150"
          r="40"
          fill="url(#onionGrad)"
          stroke="#c0a062"
          strokeWidth="2"
        />
        <text
          x="270"
          y="155"
          textAnchor="middle"
          fontSize="16"
          fontWeight="600"
          fill="currentColor"
        >
          Relay 1
        </text>
        <line
          x1="320"
          y1="150"
          x2="400"
          y2="150"
          stroke="#c0a062"
          strokeWidth="2"
          markerEnd="url(#arrow)"
        />
        <text
          x="360"
          y="135"
          textAnchor="middle"
          fontSize="11"
          fill="currentColor"
          opacity="0.6"
        >
          Encrypted
        </text>
        <circle
          cx="440"
          cy="150"
          r="40"
          fill="url(#onionGrad)"
          stroke="#c0a062"
          strokeWidth="2"
        />
        <text
          x="440"
          y="155"
          textAnchor="middle"
          fontSize="16"
          fontWeight="600"
          fill="currentColor"
        >
          Relay 2
        </text>
        <line
          x1="490"
          y1="150"
          x2="570"
          y2="150"
          stroke="#c0a062"
          strokeWidth="2"
          markerEnd="url(#arrow)"
        />
        <text
          x="530"
          y="135"
          textAnchor="middle"
          fontSize="11"
          fill="currentColor"
          opacity="0.6"
        >
          Encrypted
        </text>
        <circle
          cx="610"
          cy="150"
          r="40"
          fill="url(#onionGrad)"
          stroke="#c0a062"
          strokeWidth="2"
        />
        <text
          x="610"
          y="155"
          textAnchor="middle"
          fontSize="16"
          fontWeight="600"
          fill="currentColor"
        >
          Relay 3
        </text>
        <line
          x1="660"
          y1="150"
          x2="710"
          y2="150"
          stroke="#c0a062"
          strokeWidth="2"
          markerEnd="url(#arrow)"
        />
        <rect
          x="720"
          y="120"
          width="60"
          height="60"
          rx="8"
          fill="url(#onionGrad)"
          stroke="#c0a062"
          strokeWidth="2"
        />
        <text
          x="750"
          y="155"
          textAnchor="middle"
          fontSize="16"
          fontWeight="600"
          fill="currentColor"
        >
          Site
        </text>
      </svg>
    </div>
  );
}

function ShieldSVG() {
  return (
    <div className="lab-illustration">
      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="shieldGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#c0a062" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#c0a062" stopOpacity="0.1" />
          </linearGradient>
        </defs>
        <path
          d="M100,20 L160,50 L160,110 C160,150 130,180 100,190 C70,180 40,150 40,110 L40,50 Z"
          fill="url(#shieldGrad)"
          stroke="#c0a062"
          strokeWidth="3"
        />
        <path
          d="M80,100 L95,115 L130,80"
          stroke="#c0a062"
          strokeWidth="4"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}

function WarningSVG() {
  return (
    <div className="lab-illustration">
      <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="warningGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#c0a062" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#c0a062" stopOpacity="0.1" />
          </linearGradient>
        </defs>
        <path
          d="M100,30 L180,170 L20,170 Z"
          fill="url(#warningGrad)"
          stroke="#c0a062"
          strokeWidth="3"
        />
        <rect x="95" y="80" width="10" height="50" fill="#c0a062" rx="2" />
        <circle cx="100" cy="150" r="6" fill="#c0a062" />
      </svg>
    </div>
  );
}

function UsersSVG() {
  return (
    <div className="lab-illustration">
      <svg viewBox="0 0 300 200" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="usersGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#c0a062" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#c0a062" stopOpacity="0.1" />
          </linearGradient>
        </defs>
        <circle
          cx="80"
          cy="80"
          r="25"
          fill="url(#usersGrad)"
          stroke="#c0a062"
          strokeWidth="2"
        />
        <circle cx="80" cy="70" r="10" fill="#c0a062" opacity="0.6" />
        <rect
          x="65"
          y="90"
          width="30"
          height="40"
          rx="8"
          fill="#c0a062"
          opacity="0.4"
        />
        <circle
          cx="150"
          cy="80"
          r="25"
          fill="url(#usersGrad)"
          stroke="#c0a062"
          strokeWidth="2"
        />
        <circle cx="150" cy="70" r="10" fill="#c0a062" opacity="0.6" />
        <rect
          x="135"
          y="90"
          width="30"
          height="40"
          rx="8"
          fill="#c0a062"
          opacity="0.4"
        />
        <circle
          cx="220"
          cy="80"
          r="25"
          fill="url(#usersGrad)"
          stroke="#c0a062"
          strokeWidth="2"
        />
        <circle cx="220" cy="70" r="10" fill="#c0a062" opacity="0.6" />
        <rect
          x="205"
          y="90"
          width="30"
          height="40"
          rx="8"
          fill="#c0a062"
          opacity="0.4"
        />
        <line
          x1="105"
          y1="80"
          x2="125"
          y2="80"
          stroke="#c0a062"
          strokeWidth="2"
          opacity="0.5"
        />
        <line
          x1="175"
          y1="80"
          x2="195"
          y2="80"
          stroke="#c0a062"
          strokeWidth="2"
          opacity="0.5"
        />
      </svg>
    </div>
  );
}

// Guide-specific illustrations.
// KEY SAFETY: illustrations are scoped per-guide so they can ONLY render on the
// guide they were built for. A future blog adding `image: "shield"` to its data
// will NOT inherit the dark-web SVGs — it would need its own entry here.
// To add illustrations to a new guide, add a new key: { [slug]: { ... } }.
const GUIDE_ILLUSTRATIONS = {
  "dark-web-guide": {
    iceberg: IcebergSVG,
    onion: OnionRoutingSVG,
    shield: ShieldSVG,
    warning: WarningSVG,
    users: UsersSVG,
  },
};

function StepIllustration({ slug, imageKey }) {
  const illustrations = GUIDE_ILLUSTRATIONS[slug];
  if (!illustrations) return null;
  const Svg = illustrations[imageKey];
  return Svg ? <Svg /> : null;
}

function LabGuideDetail() {
  const { slug } = useParams();
  const { user } = useAuth();
  const meta = labGuideMeta.find((g) => g.slug === slug);

  // Full guide content fetched from server (requires auth)
  const [guide, setGuide] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!user || !meta) return;

    const fetchGuide = async () => {
      try {
        const {
          data: { session },
        } = await supabase.auth.getSession();
        if (!session) {
          setError("Authentication required");
          setLoading(false);
          return;
        }

        const res = await fetch(
          `/api/lab-guide?slug=${encodeURIComponent(slug)}`,
          {
            headers: {
              Authorization: `Bearer ${session.access_token}`,
            },
          },
        );

        const data = await res.json();

        if (!res.ok) {
          setError(data.error || "Failed to load guide");
          setLoading(false);
          return;
        }

        setGuide(data);
        setLoading(false);
      } catch {
        setError("Network error. Please try again.");
        setLoading(false);
      }
    };

    fetchGuide();
  }, [slug, user, meta]);

  if (!meta) {
    return (
      <div className="lab-page">
        <div className="container">
          <div className="lab-empty" style={{ paddingTop: "6rem" }}>
            <h1>Guide Not Found</h1>
            <Link to="/lab" className="lab-back">
              ← Back to The Lab
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // Gate: only signed-in users see full detail
  if (!user) {
    return (
      <div className="lab-page">
        <div className="container">
          <div className="lab-detail-gate">
            <span className="lab-gate__icon">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0110 0v4" />
              </svg>
            </span>
            <h2 className="lab-detail-gate__title">Sign In Required</h2>
            <p className="lab-detail-gate__text">
              Sign in to access the full step-by-step guide, tips, and
              resources.
            </p>
            <Link to="/auth" className="lab-gate__btn">
              Sign In to View Guide
            </Link>
            <Link to="/lab" className="lab-detail-gate__back">
              ← Back to The Lab
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // Loading state
  if (loading) {
    return (
      <div className="lab-page lab-detail">
        <div
          className="container"
          style={{ textAlign: "center", paddingTop: "6rem" }}
        >
          <div className="checkout__spinner">
            <div className="spinner-ring" />
          </div>
          <p style={{ color: "var(--color-text-muted)", marginTop: "1rem" }}>
            Loading guide...
          </p>
        </div>
      </div>
    );
  }

  // Error state
  if (error || !guide) {
    return (
      <div className="lab-page">
        <div className="container">
          <div className="lab-empty" style={{ paddingTop: "6rem" }}>
            <h1>Unable to Load Guide</h1>
            <p>{error || "Something went wrong."}</p>
            <Link to="/lab" className="lab-back">
              ← Back to The Lab
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const totalVoices = guide.voiceLibrary
    ? Object.values(guide.voiceLibrary).reduce(
        (sum, arr) => sum + arr.length,
        0,
      )
    : 0;

  // Long-form articles get a richer heading/body layout instead of numbered circles.
  // Treat as article when there are many sections OR the data marks it as one.
  const isArticle =
    (guide.steps && guide.steps.length >= 5) ||
    guide.sectionTitle === "In This Guide";

  return (
    <>
      <Helmet>
        <title>{meta.title} | The Lab | AxiomLabs Solutions</title>
        <meta name="description" content={meta.excerpt} />
      </Helmet>
      <div className="lab-page lab-detail">
        <div className="container">
          <Link to="/lab" className="lab-back">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Back to The Lab
          </Link>

          <div className="lab-detail__hero">
            <SectionHeading
              eyebrow={guide.readTime}
              title={guide.title}
              subheading={guide.excerpt}
            />
          </div>

          <div className="lab-detail__layout">
            {/* Video — renders a player only when videoUrl is set.
                Until then, a subtle hint reserves the intent so adding a
                video later is just dropping a URL into the guide data. */}
            {guide.videoUrl ? (
              <div className="lab-video-player">
                <iframe
                  src={guide.videoUrl}
                  title={`${guide.title} — video walkthrough`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            ) : (
              <p className="lab-video-hint">
                📹 Video walkthrough coming soon
              </p>
            )}

            {/* Featured image (for articles) */}
            {guide.featuredImage && (
              <div className="lab-detail__featured-image">
                <img src={guide.featuredImage} alt={guide.title} />
              </div>
            )}

            {/* Steps / Sections */}
            {guide.steps && (
              <section
                className="lab-detail__section"
                style={
                  guide.featuredImage
                    ? { borderTop: "none", marginTop: "1rem", paddingTop: 0 }
                    : {}
                }
              >
                <h2 className="lab-detail__section-title">
                  {guide.sectionTitle || "Step-by-Step Guide"}
                </h2>
                {guide.steps.map((step, i) => (
                  <React.Fragment key={i}>
                    <StepIllustration slug={guide.slug} imageKey={step.image} />
                    {isArticle ? (
                      <article
                        className="lab-article__section"
                        style={{ "--i": i }}
                      >
                        <h3 className="lab-article__heading">{step.title}</h3>
                        <div className="lab-article__body">
                          {step.paragraphs ? (
                            step.paragraphs.map((p, pi) => <p key={pi}>{p}</p>)
                          ) : (
                            <p>{step.text}</p>
                          )}
                        </div>
                      </article>
                    ) : (
                      <div className="lab-guide-step" style={{ "--i": i }}>
                        <span className="lab-guide-step__num">{i + 1}</span>
                        <div>
                          <strong>{step.title}</strong>
                          {step.paragraphs ? (
                            step.paragraphs.map((p, pi) => <p key={pi}>{p}</p>)
                          ) : (
                            <p>{step.text}</p>
                          )}
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </section>
            )}

            {/* Closing */}
            {guide.closing && (
              <section className="lab-detail__section">
                <h2 className="lab-detail__section-title">
                  {guide.closingTitle || "Closing"}
                </h2>
                {Array.isArray(guide.closing) ? (
                  guide.closing.map((p, i) => (
                    <p key={i} className="lab-detail__tip">
                      {p}
                    </p>
                  ))
                ) : (
                  <p className="lab-detail__tip">{guide.closing}</p>
                )}
              </section>
            )}

            {/* Tips */}
            {guide.tips && guide.tips.length > 0 && (
              <section className="lab-detail__section">
                <h2 className="lab-detail__section-title">
                  Tips for Best Results
                </h2>
                {guide.tips.map((tip, i) => (
                  <p key={i} className="lab-detail__tip">
                    {tip}
                  </p>
                ))}
              </section>
            )}

            {/* Sample Images Gallery */}
            {guide.sampleImages && guide.sampleImages.length > 0 && (
              <section className="lab-detail__section">
                <h2 className="lab-detail__section-title">Sample Outputs</h2>
                <p className="lab-detail__tip" style={{ marginBottom: "2rem" }}>
                  Real images generated with this tool — no editing or
                  post-processing.
                </p>
                <div className="prot-samples__grid">
                  {guide.sampleImages.map((img, i) => (
                    <div key={i} className="prot-samples__item">
                      <img src={img.src} alt={img.alt} loading="lazy" />
                      <span className="prot-samples__caption">{img.alt}</span>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Voice library */}
            {guide.voiceLibrary && (
              <section className="lab-detail__section">
                <h2 className="lab-detail__section-title">
                  Voice Library — {totalVoices} Voices
                </h2>
                <div className="lab-voices">
                  {Object.entries(guide.voiceLibrary).map(([group, names]) => (
                    <div key={group} className="lab-voice-group">
                      <h3>{group}</h3>
                      <div className="lab-voice-tags">
                        {names.map((v) => (
                          <span key={v} className="lab-voice-tag">
                            {v}
                          </span>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* Purchase CTA */}
            {guide.productSlug && (
              <div className="lab-detail__cta">
                <span>Ready to use this tool?</span>
                <Link
                  to={`/checkout?currency=EUR&product=${guide.productSlug}`}
                  className="lab-detail__cta-btn"
                >
                  Get This Tool →
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default LabGuideDetail;
